import { render, staticRenderFns } from "./MainContentContainer.vue?vue&type=template&id=0b04e4f1&lang=pug&"
import script from "./MainContentContainer.vue?vue&type=script&lang=js&"
export * from "./MainContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainContentContainer.vue?vue&type=style&index=0&id=0b04e4f1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports